import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import { FormattedHTMLMessage } from '@bibliocommons/react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { SecondarySolidButton } from '@bibliocommons/base-buttons';
import { SecondaryLink } from '@bibliocommons/base-links';
import { libraryShape, promoShape } from '@bibliocommons/bc-prop-types';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';

import cardShape from 'app/shapes/cardShape';
import ContentCard from 'app/components/cards/ContentCard';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import { hasPromosEnabled } from 'app/helpers/library/features';

import './PersonalizedPromotions.scss';

export default class PersonalizedPromotions extends React.PureComponent {
  modalKey = `personalized-promotions-info-modal-${this.props.position}`;

  openModal = () => this.props.modalActions.openModal(this.modalKey, { authRequired: false });

  closeModal = () => this.props.modalActions.closeModal(this.modalKey);

  renderInfoLink() {
    return (
      <SecondaryLink
        className="info-link"
        href="#cards-info-modal"
        handleClick={this.openModal}
        dataKey="info-modal-link"
        preventDefault
      >
        <FormattedMessage id="why_seeing_this" />
      </SecondaryLink>
    );
  }

  renderInfoModal() {
    const { currentLibrary } = this.props;
    const libraryName = currentLibrary.get('fullName');

    return (
      <ModalContainer modalKey={this.modalKey} handleClose={this.closeModal}>
        <ModalHeader title={<FormattedMessage id="about_this_content" />} />
        <ModalContent>
          <FormattedHTMLMessage id="content_cards_info" values={{ libraryName }} />
        </ModalContent>
        <ModalFooter
          secondaryActionButtonText={<FormattedMessage id="button_close" />}
          secondaryActionButtonTag={SecondarySolidButton}
          renderPrimaryAction={() => null}
        />
      </ModalContainer>
    );
  }

  render() {
    const { debugEnabled, promos, currentLibrary, interestedEvents, features } = this.props;
    const cmsUrl = hasPromosEnabled(currentLibrary) ? currentLibrary.get('cmsUrl') : null;
    const compact = this.props.cards.size > 1;
    const classNames = cn('cp-personalized-promotions', {
      'personalized-promotions--compact': compact
    });
    const isInterestedEventsEnabled =
      features?.get(TOGGLZ_FEATURES.ENABLE_EVENTS_INTERESTED) && currentLibrary.getIn(['events', 'myEventsEnabled']);

    return (
      <aside className={classNames}>
        <div className="content-cards">
          {this.props.cards.map(card => (
            <ContentCard
              compact={compact}
              card={card}
              key={card.get('id')}
              debugEnabled={debugEnabled}
              promo={promos?.get(card?.get('id').toString())}
              cmsUrl={cmsUrl}
              isInterestedEventsEnabled={isInterestedEventsEnabled}
              interestedEvents={interestedEvents}
              handleTitleClick={this.props.handleTitleClick}
              handleImageClick={this.props.handleImageClick}
              handleContentImpression={this.props.handleContentImpression}
              handleContentExplore={this.props.handleContentExplore}
              handleCardEventInterestedClick={this.props.handleCardEventInterestedClick}
            />
          ))}
        </div>
        <div className="personalized-promotions-footer">{this.renderInfoLink()}</div>
        {this.renderInfoModal()}
      </aside>
    );
  }
}

PersonalizedPromotions.propTypes = {
  position: PropTypes.number.isRequired,
  cards: ImmutablePropTypes.listOf(cardShape),
  currentLibrary: libraryShape.isRequired,
  debugEnabled: PropTypes.bool,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  promos: ImmutablePropTypes.mapOf(promoShape).isRequired,
  features: ImmutablePropTypes.mapOf(PropTypes.bool, PropTypes.oneOf(Object.values(TOGGLZ_FEATURES))).isRequired,
  interestedEvents: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      registrationId: PropTypes.string.isRequired,
      eventIds: PropTypes.object.isRequired
    })
  ),
  handleTitleClick: PropTypes.func.isRequired,
  handleImageClick: PropTypes.func.isRequired,
  handleContentImpression: PropTypes.func.isRequired,
  handleContentExplore: PropTypes.func.isRequired,
  handleCardEventInterestedClick: PropTypes.func.isRequired
};
